import React, { useState } from 'react';
import { Container, Table,Row, Col } from 'reactstrap';
import { WhitePanelLayout } from '@dom/components';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import format from 'date-fns/format';
import { makeUrl } from '@dom/utils';
import { Head } from '@dom/components';
import config from '@dom/config';

import { CardsSlider } from '../../components';
import { LodgeCard } from '@dom/components';

import { useEffectOnFirstRender } from '../../hooks';
import fetchInvoiceData from '../../api/fetchInvoiceData';
import { getLocaleString } from '../../utils';

const { goToLodge, goToFlight } = makeUrl;

function GuidePaymentSuccess(props) {
  const [invoiceData, setInvoiceData] = useState(null); 
  const { location } = props;
  const { invoiceId } = queryString.parse(location.search);

  useEffectOnFirstRender(() => {
    async function awaitInvoiceData() {
      const data = await fetchInvoiceData(invoiceId);
      setInvoiceData(data);
    };
    awaitInvoiceData();
  });

  const { lineItems, invoice } = invoiceData || { lineItems: [{}], invoice: {} };
  const { createdOn } = lineItems[0];
  const date = createdOn && format(createdOn, 'MMMM D, YYYY');

  const { discount, amount } = invoice;
  const hasDiscount = Number(discount);

  return (
    <Head title="Payment Succes">
      <Container>
        <Row>
          <Col sm="6">
            <WhitePanelLayout>
              <div>
                <h5 >Payment Successful!</h5>

                <p>Your order has been confirmed.</p>
                <p>Please check your email for the details. Also, please check your spam folder too. 
                  If you don’t receive the confirmation within 30 minutes, please email us at 
                  <a target="_blank" href={`mailto:${config.honeyguideEmail}`} rel="noopener noreferrer nofollow">{config.honeyguideEmail}</a> 
                  or call / whatsapp us at 
                  <a style={{ color: '#3A5DB7' }} target="_blank" href={`https://wa.me/${config.honeyguidePhoneNumber}`} rel="noopener noreferrer nofollow">{config.honeyguidePhoneNumber}</a>.
                </p>
                <br/>          

                {/* <Button color="yellow" className="mt-4">Go to Home</Button> */}
                <br/>
                <p>You can also <a href={goToLodge} style={{ color: '#3A5DB7' }}>Book Lodges</a> and <a href={goToFlight} style={{ color: '#3A5DB7' }}>Flights</a> through HoneyGuide. Do check it out.</p>
              </div>
            </WhitePanelLayout>
          </Col>
          <Col sm="6">
            {
              invoiceData && (
                <>
                <h5 style={{ textAlign: 'center' }}>Payment Details</h5>
                <Table striped>
                  <tbody>
                    <TableRow title="Invoice Id" value={invoiceId} />
                    <TableRow title="Date" value={date} />
                    <TableRow title="Payment Utility" value="Guide" />
                    {hasDiscount ? (
                      <React.Fragment>
                        <TableRow title="SubTotal (USD)" value={amount} />
                        <TableRow title="Discount (USD)" value={discount} />
                      </React.Fragment>
                    ) : null}
                    <TableRow title="Total amount (USD)" value={getLocaleString(amount)} />
                    </tbody>
                </Table>
                </>
              )
            }
          </Col>
        </Row>
        <CardsSlider
            title="Featured Lodges"
            endpoint="lodgings/lodges?is_featured=1"
            Card={LodgeCard}
          />
      </Container>
    </Head>
  )
};

export default withRouter(GuidePaymentSuccess);

const TableRow = ({ title, value }: { title: string, value: string | number }) => {
  return (
    <tr>
      <td>{title}</td>
      <td>{value}</td>
    </tr>
  );
};
